import { createTheme } from "@mantine/core";
var brand = [
    "#f3f3fd",
    "#dedffa",
    "#bdbef2",
    "#8184ef",
    "#4349ef",
    "#0b12ea",
    "#0208b3",
    "#02068b",
    "#010567",
    "#010347",
];
export var coreTheme = createTheme({
    colors: { brand: brand },
    primaryColor: "brand",
    primaryShade: 6,
    fontSizes: {
        xs: "11px",
        sm: "12px",
        md: "13px",
        lg: "14px",
        xl: "20px",
    },
    spacing: {
        xs: "4px",
        sm: "8px",
        md: "16px",
        lg: "20px",
        xl: "24px",
    },
    radius: {
        xs: "10px",
        sm: "10px",
        md: "14px",
        lg: "14px",
        xl: "20px",
    },
});
export var coreTokens = {
    ink: "#0f0e2e",
    text2: "#565c6e",
    text3: "#6b7280",
    bg: "#f6f7fc",
    shadow: "0 1px 3px rgba(2, 8, 179, 0.06), 0 4px 16px rgba(2, 8, 179, 0.07)",
    fontSizeXxl: "25px",
    fontSizeXxxl: "30px",
};
